<template>
  <TooltipRoot data-slot="tooltip" v-bind="forwarded">
    <slot />
    <TooltipContent v-if="text">{{ text }}</TooltipContent>
  </TooltipRoot>
</template>

<script setup lang="ts">
import { reactiveOmit } from "@vueuse/core";
import {
  TooltipRoot,
  type TooltipRootEmits,
  type TooltipRootProps,
  useForwardPropsEmits,
} from "reka-ui";
import TooltipContent from "./TooltipContent.vue";

interface Props extends TooltipRootProps {
  text?: string;
}

const props = defineProps<Props>();
const emits = defineEmits<TooltipRootEmits>();

const delegatedProps = reactiveOmit(props, "text");
const forwarded = useForwardPropsEmits(delegatedProps, emits);
</script>
